var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarSelect({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9664 8.64227C23.8876 8.42151 23.6983 8.24804 23.4618 8.21649L16.1915 7.00213L12.5485 0.33117C12.4381 0.12616 12.2331 0 11.9966 0C11.76 0 11.555 0.12616 11.4446 0.33118L7.80156 7.00214L0.531299 8.21649C0.294789 8.24805 0.105519 8.42151 0.0266587 8.64227C-0.0363913 8.8631 0.0109187 9.09961 0.184379 9.27313L5.64098 14.714L4.42669 21.9684C4.37933 22.1892 4.47399 22.4258 4.6632 22.5677C4.85247 22.7097 5.10479 22.7412 5.30981 22.6465L11.9808 19.6186L18.6517 22.6465C18.7464 22.6939 18.8252 22.7097 18.9199 22.7097C19.0618 22.7097 19.1879 22.6623 19.3456 22.5677C19.5349 22.4258 19.6138 22.205 19.5822 21.9684L18.3678 14.714L23.8087 9.27312C23.9822 9.11542 24.0453 8.8631 23.9664 8.64227Z",
    fill: "#CDA600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarSelect);
export default __webpack_public_path__ + "static/media/starSelect.a5f812ffe042494421b3f118efaf0a57.svg";
export { ForwardRef as ReactComponent };